export default {"src":"/_next/static/media/500.1b5afc78.svg","height":656,"width":1200,"blurWidth":0,"blurHeight":0};